import Vue from 'vue'
import App from './App.vue'
import router from './router'
import iView from 'iview'  
import 'iview/dist/styles/iview.css'  

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueResource from 'vue-resource'

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'



Vue.config.productionTip = false
Vue.use(iView)
Vue.use(ElementUI)
Vue.use(VueResource)
Vue.use(VideoPlayer)

//创建总线
const Bus = new Vue();
//将总线添加到Vue原型中(方便所有的Vue实例使用)
Vue.prototype.$Bus = Bus;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
